import { render } from "./privacypolicy.vue?vue&type=template&id=07d6e24c&scoped=true"
const script = {}

import "./privacypolicy.vue?vue&type=style&index=0&id=07d6e24c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d6e24c"]])

export default __exports__